// Carga del SDK oficial de Facebook para el flujo OAuth en ventana nueva (popup).
let fbPromise = null;

export function loadFacebookSDK(appId) {
  if (fbPromise) return fbPromise;
  fbPromise = new Promise((resolve, reject) => {
    if (!appId) {
      reject(new Error("missing_app_id"));
      return;
    }
    window.fbAsyncInit = function () {
      window.FB.init({ appId, cookie: true, xfbml: false, version: "v21.0" });
      resolve(window.FB);
    };
    const id = "facebook-jssdk";
    if (document.getElementById(id)) {
      if (window.FB) resolve(window.FB);
      return;
    }
    const js = document.createElement("script");
    js.id = id;
    js.src = "https://connect.facebook.net/es_LA/sdk.js";
    js.async = true;
    js.defer = true;
    js.crossOrigin = "anonymous";
    js.onerror = () => reject(new Error("sdk_load_error"));
    document.body.appendChild(js);
  }).catch((e) => {
    fbPromise = null; // permitir reintentos si falla la carga
    throw e;
  });
  return fbPromise;
}

// Abre el popup de login oficial de Facebook/Meta y devuelve la authResponse.
export function fbLogin(FB, scope) {
  return new Promise((resolve, reject) => {
    FB.login(
      (response) => {
        if (response && response.authResponse) resolve(response.authResponse);
        else reject(new Error("cancelado"));
      },
      { scope, return_scopes: true }
    );
  });
}
